import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { saveAs } from 'file-saver';

import { Bulletin } from '../bulletin';
import { BulletinFile } from '../bulletin-file';
import { BulletinService } from '../bulletin.service';
import { BulletinFilter } from '../bulletin-filter';
import { BulletinTypeService } from 'src/app/masters/bulletin-type/bulletin-type.service';
import { BulletinType } from 'src/app/masters/bulletin-type/bulletin-type';
import { Vehicle } from 'src/app/masters/vehicle/vehicle';
import { RepairGroup } from 'src/app/masters/repair-group/repair-group';
import { VehicleService } from 'src/app/masters/vehicle/vehicle.service';
import { RepairGroupService } from 'src/app/masters/repair-group/repair-group.service';
import { UserService } from 'src/app/core/auth/user.service';
import { RoleService } from 'src/app/masters/role/role.service';
import { Role } from 'src/app/masters/role/role';
import { Status } from 'src/app/masters/status/status';
import { StatusService } from 'src/app/masters/status/status.service';
import { BulletinReport } from '../bulletin-report';
import { Router } from '@angular/router';
import { Message, SortEvent } from 'primeng/api';
import { SnackBarService } from '../../service/snack-bar.service'
import { Subscription } from 'rxjs';
import { Page } from '../../entities/pages/page';
import { PaginationService } from 'src/app/service/pagination.service';
import { ReturnService } from 'src/app/core/interfaces/return-service';


@Component({
    templateUrl: './bulletin-list.component.html',
    styleUrls: ['./bulletin-list.component.css']
})
export class BulletinListComponent implements OnInit, AfterViewInit  {

    showPagination = false;
    @ViewChild('sortableColumn') sortableColumnRef!: ElementRef;

    cols: any[];
    msgs: Message[] = [];

    bulletinTypes: BulletinType[] = [];
    vehiclesFull: Vehicle[] = [];
    vehicles: Vehicle[] = [];
    repairGroups: RepairGroup[] = [];
    roles: Role[] = [];
    statuslist: Status[] = [];

    filter: BulletinFilter;
    bulletins: Bulletin[] = [];
    internalUser: boolean;

    showFileDialog: boolean = false;
    selectedBulletin: Bulletin;
    files: BulletinFile[] = [];
    subscription: Subscription;
    totalRecords: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    pageLinks: number;
    page: Page<BulletinFile>;
    bulletin: Bulletin;

    constructor (
        private router: Router,
        private bulletinTypeService: BulletinTypeService,
        private vehicleService: VehicleService,
        private repairGroupService: RepairGroupService,
        private bulletinService: BulletinService,
        private roleService: RoleService,
        private userService: UserService,
        private statusService: StatusService,
        private snackBar: SnackBarService,
        private paginationService: PaginationService,
    ) {
        this.page = new Page();
        this.filter = new BulletinFilter();
        this.totalRecords = 0;
        this.pageNumber = 1;
        this.pageSize = 10;
    }
    ngAfterViewInit(): void {
        
    }

    ngOnInit() {
        const currentDate = new Date();
        const endDate = currentDate.toISOString().substring(0, 10);

        const startDate = new Date();
        startDate.setMonth(currentDate.getMonth() - 3);
        const startDateFormatted = startDate.toISOString().substring(0, 10);

        this.filter.startDate = startDateFormatted;
        this.filter.endDate = endDate;
        this.initCombo();

        this.internalUser = this.userService.isTdbUser();

        this.cols = [
            { field: 'bulletinType.description', header: 'Tipo' },
            { field: 'code', header: 'Código' },
            { field: 'description', header: 'Descrição' },
            { field: '', header: 'Detalhe' },
            { field: 'updateDate', header: 'Data' }
        ];

        if (history.state.filter) {
            this.filter = history.state.filter;
            this.search();
        }

    }

    loadData() {
        this.search();
    }
    sortData(event: any) {
        // Verifique se a coluna clicada é a coluna "Data"
        const element =  this.sortableColumnRef.nativeElement;
        const sortableColumnElement = element.children[4];
        if (event.target.innerText.includes("Data") || event.target.offsetParent.innerText.includes("Data")) {
          // Ordenar os dados manualmente
         
          const sortableChild = sortableColumnElement.children[0].children[0];
          const order = sortableChild.classList.contains('pi-sort-amount-down') ? 'desc' : 'asc';

            this.page.content.sort((a, b) => {
                const dateA = new Date(a.insertDate);
                const dateB = new Date(b.insertDate);
                return order === 'asc' ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
              });
        }
      }
    handlePageChange(event: any) {
        this.pageSize = event.rows;
        this.pageNumber = (event.first / this.pageSize) + 1;
        this.loadData();
        this.showPagination = true;
    }

    search() {
        if (this.filter.bulletinType === null || this.filter.bulletinType === undefined) {
            this.msgs.push({ severity: 'error', detail: 'O campo Tipo não pode estar vazio! ' });
            return;
        }
        if ((this.filter.endDate == null && this.filter.startDate == null)) {
            this.msgs.push({ severity: 'error', detail: 'O campo De e Até não podem estar vazio! ' });
            return;
        }
        else {
            this.subscription = this.bulletinService.searchNew(this.filter, this.page.pageable)
                .subscribe(result => {
                    this.page = result.data;        
                    this.paginationService.updatePagination.emit(this.page);
                },
                    errorResponse => {
                        this.page = new Page();
                        this.paginationService.updatePagination.emit(errorResponse.data);
                    }
                );
        }
    }

    edit(id: number) {
        this.router.navigate(['bulletin', id], { state: { filter: this.filter } });
    }

     delete(item: Bulletin) {
         if (item.id != null) {
             this.bulletinService.delete(item.id).subscribe((data: ReturnService) => {
                 if (data.severity == "success") {
                     const deletedItem = this.bulletins.find(x => x.id === item.id);
                     this.bulletins.splice(this.bulletins.indexOf(deletedItem), 1);
                 }
 
                 this.msgs = [{
                     severity: data.severity,
                     detail: data.detail
                 }];
                 this.search();
             });
         }
     }

    openFileDialog(item: Bulletin) {

        this.bulletinService.find(item.id).subscribe(it => {
            this.files = it.files;
            this.showFileDialog = true;
            this.selectedBulletin = item;
        });
    }

    donwloadAll(item: Bulletin) {
        this.bulletinService.find(item.id).subscribe(it => {
            this.selectedBulletin = item;
            it.files.forEach(f => {
                let report = new BulletinReport();
                report.bulletinCode = this.selectedBulletin.code;
                report.bulletinDescription = this.selectedBulletin.description;
                report.dealerNumber = this.userService.getDealerNumber();
                report.vehicle = this.selectedBulletin.vehicle?.description;
                report.lastUpdate = (this.selectedBulletin.updateDate == null) ? this.selectedBulletin.insertDate : this.selectedBulletin.updateDate;
                report.usrLastUpdate = (this.selectedBulletin.updateUser == null) ? this.selectedBulletin.insertUser : this.selectedBulletin.updateUser;

                let user = this.userService.getUserName();
                this.bulletinService.download(f, report, user).subscribe(
                    (ret: Blob) => {
                        saveAs(ret, f.fileName);
                    }
                );
            });


        });
    }

    downloadFile(file: BulletinFile) {

        let report = new BulletinReport();
        report.bulletinCode = this.selectedBulletin.code;
        report.bulletinDescription = this.selectedBulletin.description;
        report.dealerNumber = 'TDB';
        report.vehicle = this.selectedBulletin.vehicle?.description;
        report.lastUpdate = (this.selectedBulletin.updateDate == null) ? this.selectedBulletin.insertDate : this.selectedBulletin.updateDate;
        report.usrLastUpdate = (this.selectedBulletin.updateUser == null) ? this.selectedBulletin.insertUser : this.selectedBulletin.updateUser;

        let user = this.userService.getUserName();
        this.bulletinService.download(file, report, user).subscribe(
            (ret: Blob) => {
                saveAs(ret, file.fileName);
            }
        );
    }

    closeFileDialog(event) {
        this.showFileDialog = false;
        this.selectedBulletin = null;
        this.files = [];

        return false;
    }
    initCombo() {
        this.bulletinTypeService.findAll().subscribe(items => {
            this.bulletinTypes = items.filter(x => x.status.id == 1);
        });

        this.vehicleService.findAll().subscribe(items => {
            this.vehiclesFull = items.filter(x => x.status.id == 1);
            this.vehicles = this.vehiclesFull;
        });

        this.repairGroupService.findAll().subscribe(items => {
            this.repairGroups = items.filter(x => x.status.id == 1);
        });

        this.roleService.findAll().subscribe(items => {
            this.roles = items.filter(x => x.status.id == 1);
        });

        this.statusService.findAll().subscribe(status => {
            this.statuslist = status.filter(x => x.type == "Boletim");
        });
    }

    firstPageHandler() {
        this.page.pageable = this.paginationService.getFirstPage(this.page);
        this.search();

    }

    pageSizeHandler(pageSize: number) {
        this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
        this.search();
    }

    lastPageHandler() {
        this.page.pageable = this.paginationService.getLastPage(this.page);
        this.search();
    }
    ngOndetroy() {
        this.subscription.unsubscribe();
    }

    nextPageHandler() {
        this.page.pageable = this.paginationService.getNextPage(this.page);
        this.search();

    }

    previousPageHandler() {
        this.page.pageable = this.paginationService.getPreviousPage(this.page);
        this.search();

    }


}